import { ArrowUpRight, Check } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { mediaUrl } from "@/lib/api";
import EmailCapture from "@/components/EmailCapture";

export function CommunityPromo({ compact }) {
  const { settings } = useSite();
  const c = settings.community;
  if (compact)
    return (
      <div className="flex flex-col gap-5 rounded-[28px] bg-bt-sage p-7 sm:flex-row sm:items-center sm:justify-between" data-testid="community-promo-compact">
        <div>
          <p className="font-heading text-2xl text-bt-heading">{c.headline}</p>
          <p className="mt-1 text-bt-text">{c.body}</p>
        </div>
        <a href={c.url} target="_blank" rel="noopener noreferrer" className="btn-primary shrink-0" data-testid="community-compact-cta">
          {c.cta} <ArrowUpRight size={18} />
        </a>
      </div>
    );
  return (
    <section className="relative overflow-hidden rounded-[36px] bg-bt-primary text-bt-bg grain" data-testid="community-promo">
      <div className="grid lg:grid-cols-2">
        <div className="relative z-10 p-8 sm:p-14">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] opacity-70">{c.eyebrow}</p>
          <h2 className="text-4xl leading-tight sm:text-5xl" style={{ color: "var(--bt-background)" }}>{c.headline}</h2>
          <p className="mt-5 max-w-lg text-base opacity-90 md:text-lg">{c.body}</p>
          {c.points?.length > 0 && (
            <ul className="mt-7 space-y-3">
              {c.points.map((p) => (
                <li key={p} className="flex items-center gap-3"><span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/15"><Check size={14} /></span>{p}</li>
              ))}
            </ul>
          )}
          <a href={c.url} target="_blank" rel="noopener noreferrer" data-testid="community-cta-button"
            className="mt-9 inline-flex min-h-[52px] items-center gap-2 rounded-full bg-bt-bg px-7 py-3 font-semibold text-bt-primary transition-transform duration-300 hover:-translate-y-0.5">
            {c.cta} <ArrowUpRight size={18} />
          </a>
        </div>
        {c.image && (
          <div className="relative min-h-[260px]">
            <img src={mediaUrl(c.image)} alt="" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
            <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, var(--bt-primary) 0%, transparent 45%)" }} />
          </div>
        )}
      </div>
    </section>
  );
}

export function LeadMagnet() {
  const { settings } = useSite();
  const lm = settings.lead_magnet;
  if (!lm.enabled) return null;
  return (
    <section className="grid overflow-hidden rounded-[36px] border border-bt-border bg-bt-sage lg:grid-cols-[0.9fr_1.1fr]" data-testid="lead-magnet">
      {lm.image && (
        <div className="relative min-h-[240px]">
          <img src={mediaUrl(lm.image)} alt="" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
        </div>
      )}
      <div className="p-8 sm:p-12">
        <p className="eyebrow mb-3">{lm.eyebrow}</p>
        <h2 className="text-3xl leading-tight sm:text-4xl" data-testid="lead-magnet-title">{lm.title}</h2>
        <p className="mb-7 mt-4 text-base md:text-lg">{lm.description}</p>
        <EmailCapture variant="lead" />
      </div>
    </section>
  );
}
